export default {
    rowsPerPage: 10,
    page: 1,
};
